import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class IndicatorService {
  
  httpHeaders = new HttpHeaders({'Content-type': 'application/json'});
  indicatorsUrl: string;
  companiesUrl: string;

  constructor(private http: HttpClient) {
    this.indicatorsUrl = environment.getBackendUrl('indicators');
    this.companiesUrl = environment.getBackendUrl('companies');
    
  }

  getIndicator(): Observable<any> {
    return this.http.get(this.indicatorsUrl + '/latest/',
    {
      headers: this.httpHeaders
    } );
  }

  getAffiDavits(): Observable<any> {
    const body = {
      company_uuid: JSON.parse(localStorage.getItem('currentUser'))['company_uuid'],
    }
    return this.http.get(this.companiesUrl + '/affidavits/',
    {
      params: body,
      headers: this.httpHeaders
    } );
  }

  getDataF29(): Observable<any> {
    const body = {
      company_uuid: JSON.parse(localStorage.getItem('currentUser'))['company_uuid'],
    }
    return this.http.get(this.companiesUrl + '/data_f29/',
    {
      params: body,
      headers: this.httpHeaders
    } );
  }

  statusF29(): Observable<any> {
    const body = {
      company_uuid: JSON.parse(localStorage.getItem('currentUser'))['company_uuid'],
    }
    return this.http.get(this.companiesUrl + '/status_f29/',
    {
      params: body,
      headers: this.httpHeaders
    } );
  }

  updateStatusF29(period): Observable<any> {

    return this.http.get(this.companiesUrl + '/get_f29_situation/'+period+'/',
    {
      headers: this.httpHeaders
    } );
  }

  rentalDeclaration(): Observable<any> {
    const body = {
      company_uuid: JSON.parse(localStorage.getItem('currentUser'))['company_uuid'],
    }
    return this.http.get(this.companiesUrl + '/rental_declaration/',
    {
      params: body,
      headers: this.httpHeaders
    } );
  }
  

  updateRentalDeclaration(): Observable<any> {

    return this.http.get(this.companiesUrl + '/update_rental/',
    {
      headers: this.httpHeaders
    } );
  }

}
